import {Component, ElementRef, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {TranslateService} from "../../shared/translate.service";
import {MessageService} from "../../messages/message.service";

@Component({
  selector: 'app-download-button',
  templateUrl: './download-button.component.html',
  styleUrls: ['./download-button.component.scss']
})
export class DownloadButtonComponent implements OnInit {

  @Input()
  id: string;

  @Input()
  type: string;

  @Input()
  idSource: string;

  @ViewChild('myDropdown') myDropdown: ElementRef;

  downloadLabel = this.translateService.translate('ResultItem.download');

  constructor(private http: HttpClient,
              private translateService: TranslateService,
              private messageService: MessageService,
              private eRef: ElementRef) {
  }

  ngOnInit() {
  }

  downloadOMNIS() {
    this.http.get(`apiServiceUrl/api/structure/${this.id}/${this.type}`, {responseType: 'blob'})
      .subscribe(res => {
        this.downloadFile(res, `Opis_bibliograficzny_${this.id}.json`);
      }, error => {
        console.log('download error:', JSON.stringify(error));
        this.messageService.errorMessage('download.button.error.title', 'download.button.error.message');
      });
  }

  downloadSourceRecord() {
    this.http.get(`storageUrl/source/${this.idSource}`, {responseType: 'blob'})
      .subscribe(res => {
        this.downloadFile(res, `Rekord_zrodlowy_${this.idSource}.txt`);
      }, error => {
        console.log('download error:', JSON.stringify(error));
        this.messageService.errorMessage('download.button.error.title', 'download.button.error.message');
      });
  }

  downloadRIS() {
    this.http.get(`apiUrl/omnis/export/ris/${this.id}`, {responseType: 'blob'})
      .subscribe(res => {
        this.downloadFile(res, `Opis_bibliograficzny_${this.id}.ris`);
      }, error => {
        console.log('download error:', JSON.stringify(error));
        this.messageService.errorMessage('download.button.error.title', 'download.button.error.message');
      });
  }

  downloadBibTex() {
    this.http.get(`apiUrl/omnis/export/bibtex/${this.id}`, {responseType: 'blob'})
      .subscribe(res => {
        this.downloadFile(res, `Opis_bibliograficzny_${this.id}.bib`);
      }, error => {
        console.log('download error:', JSON.stringify(error));
        this.messageService.errorMessage('download.button.error.title', 'download.button.error.message');
      });
  }

  private downloadFile(res, fileName: string) {
    let url = window.URL.createObjectURL(res);
    let a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  hideContent() {
      setTimeout(()=>{
        if(this.myDropdown.nativeElement.classList.contains('show')){
          this.myDropdown.nativeElement.classList.toggle('show');
        }
      }, 300);
  }
}
